import * as React from "react";

import { makeStyles } from "@mui/styles";
import ToggleSwitch from "./ToggleSwitch";

const useStyles = makeStyles({
    root: {
        // border: '1px solid #B0B0B0',
        borderRadius: 10,
        position: "relative",
        display: "flex",
        justifyContent: "center",
        padding: "11px 10px",
        "& p": {
            position: "absolute",
            top: "-14px",
            left: "10px",
            background: "white",
            width: "-moz-fit-content",
            width: "fit-content",
            padding: "2px 8px",
            font: "normal normal normal 14px/21px Poppins",
            letterSpacing: "0px",
            color: "#505050",
        },
        "& .MuiTabs-root": {
            minHeight: "32px",
        },
        "& .MuiTabs-indicator": {
            height: 32,
            minHeight: 32,
        },
        "& .MuiButtonBase-root": {
            height: 32,
            minHeight: 32,
            minWidth: "fit-content",
        },
    },
});

export default function CountrySelection({
    label,
    handleChange,
    value,
    options,
    name,
}) {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            {label && <p>{label}</p>}
            <ToggleSwitch
                handleChange={handleChange}
                value={value}
                options={options}
                name={name}
            />
        </div>
    );
}
